// This object defines the exact role strings your Spring Boot backend sends.
export const ROLES = Object.freeze({
    ADMINS: 'ROLE_ADMINS',
    SUPPORT: 'ROLE_SUPPORT',
    VIEWERS: 'ROLE_VIEWERS',
});

export const getAllAppRoles = () => Object.values(ROLES);